import { Component, HostBinding, inject, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Overlay, OverlayService } from '@services/overlay';

@Component({
  selector: 'lv-overlays',
  templateUrl: './overlays.component.html',
  styleUrls: ['./overlays.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OverlaysComponent implements OnInit {
  private overlayService = inject(OverlayService);

  @ViewChild('overlayContainer', { static: true, read: ViewContainerRef }) overlayContainer: ViewContainerRef;

  @HostBinding('hidden') get hidden(): boolean {
    return !this.anyOverlays();
  }

  ngOnInit() {
    this.overlayService.overlaysChanged.asObservable().subscribe((overlay) => this.openOverlay(overlay));
  }

  anyOverlays(): boolean {
    return this.overlayService.overlays.length > 0;
  }

  openOverlay(overlay: Overlay) {
    const ref = this.overlayContainer.createComponent(overlay.component);
    const instance = ref.instance;
    for (const key in overlay.input) {
      instance[key] = overlay.input[key];
    }
    ref.changeDetectorRef.detectChanges();
    overlay.close.asObservable().subscribe(() => ref.destroy());
  }
}
